import * as React from 'react'
import ReadService from "../../../service/read";
import Wait from "../../wait";
import PopDetail from "../../popdetail";
import PlotDetailPane from "../plot/plot_detail_pane";
import AddDocumentPane from "../../add/add_document";
import CCROAddNewLayerPane from "../../add/ccro_add_new_layer";
import CCROUploadShpPane from "../../add/ccro_upload_shp";
import CreateService from "../../../service/create";
import {ProjectsService} from "../../../service/v1/projects";
import CollectService from "../../../service/v1/collect";
import baseUrl from "../../../service/baseURL";

export default class CCROGISApprovalPane extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            data: [],
            search:'',
            show_actions: this.props.can_edit ? 'table-cell' : 'none',
            villages:[],
            village_id:0,
            totalPages: 1,
            next: null,
            previous: null,
            pageSize: 50,
            newPageSize: 50
        }
        this.loadData = this.loadData.bind(this)
        this.loadLocalities = this.loadLocalities.bind(this)
        this.handleChanges = this.handleChanges.bind(this)
    }

    componentDidMount() {
        this.loadLocalities()
    }

    handleChanges=(e)=>{
        this.setState({
            [e.target.name]:e.target.value
        })
    }

    loadLocalities() {
        try{
            Wait.show('Loading Villages...')
            ReadService.fetchLocalitiesByProject(this.props.project.id).then(r=>{
                try {
                    let data = r.data.results

                    console.log(data)
                    this.setState({
                        villages:data,
                        village_id:data[0].id
                    })

                    setTimeout(()=>this.loadData(), 500)
                }catch (e) {
                    console.log(e)
                }


            })
        }catch (e) {
            console.log(e)
        }

    }

    downloadExcel(){
        try {
            Wait.show('Generating Excel....')
            let village_id = this.state.village_id
            CreateService.downloadExcel(village_id).then(response => {
                Wait.dismiss()
                const url = window.URL.createObjectURL(new Blob([response.data]));

                  // Create a temporary link element
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'Public_Display.xlsx'); // Specify the filename

                  // Simulate a click on the link to trigger the file download
                document.body.appendChild(link);
                link.click();

                  // Clean up the temporary objects
                link.remove();
                window.URL.revokeObjectURL(url);

            })
        }catch (e) {
            console.log(e)
        }
    }

    loadData() {
        try {
            Wait.show('Fetching Draft Data....')
            ReadService.fetchCCRODataByStage(this.props.project.id,'gis_approval',this.state.village_id).then(r=>{
                Wait.dismiss()
                this.setState({
                    data:r.data.results,
                    totalPages: Math.ceil(r.data.count / this.state.pageSize),
                    next: r.data.next,
                    previous: r.data.previous,
                    count: r.data.count
                })
            })
        }catch (e) {

        }
    }

    searchData() {
        try {
            Wait.show('Searching....')
            ReadService.searchCCRODataByStage(this.props.project.id,this.state.search.replaceAll('/','_'),this.state.village_id).then(r=>{
                Wait.dismiss()
                this.setState({
                    data:r.data.results,
                    totalPages: Math.ceil(r.data.count / this.state.pageSize),
                    next: r.data.next,
                    previous: r.data.previous,
                    count: r.data.count
                })
            })
        }catch (e) {

        }
    }

    fetchProjectsByUrl(url) {
        try {
            Wait.show('Fetching Projects...')
            ProjectsService.fetchProjectsByUrl(url).then(r => {
                Wait.dismiss()
                try {
                    this.setState({
                        data: r.data.results,
                        totalPages: Math.ceil(r.data.count / this.state.pageSize),
                        next: r.data.next,
                        previous: r.data.previous,
                        count: r.data.count
                    })
                } catch (e) {
                    console.log(e)
                }
            })
        } catch (e) {
            console.log(e)
        }
    }

    render() {
        const fontFamily = 'Poppins, Inter, Open Sans, Helvetica, Arial, sans-serif';
        
        const container = {
            width: '100%',
            height: '100%',
            overflow: 'hidden',
            fontFamily,
            background: '#f6f8fa'
        };
        
        const header = {
            background: 'transparent',
            color: '#395d9a',
            padding: '16px 24px',
            display: 'flex',
            flexWrap: 'wrap',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: '16px',
            borderBottom: '1px solid #e0e7ef'
        };
        
        const headerLeft = {
            display: 'flex',
            alignItems: 'center',
            gap: '12px'
        };
        
        const headerTitle = {
            fontSize: '18px',
            fontWeight: '700',
            color: '#395d9a',
            display: 'flex',
            alignItems: 'center',
            gap: '8px'
        };
        
        const headerRight = {
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            fontSize: '12px',
            color: '#666'
        };
        
        const controlsSection = {
            padding: '16px 24px',
            background: 'white',
            borderBottom: '1px solid #e0e7ef',
            display: 'flex',
            flexWrap: 'wrap',
            alignItems: 'center',
            gap: '12px'
        };
        
        const totalCount = {
            fontSize: '16px',
            fontWeight: '700',
            color: '#27ae60',
            display: 'flex',
            alignItems: 'center',
            gap: '8px'
        };
        
        const searchInput = {
            padding: '8px 12px',
            border: '1px solid #e0e7ef',
            borderRadius: 0,
            fontSize: '14px',
            minWidth: '300px',
            fontFamily
        };
        
        const button = {
            padding: '8px 16px',
            border: 'none',
            borderRadius: 0,
            fontSize: '14px',
            fontWeight: '600',
            cursor: 'pointer',
            transition: 'all 0.2s ease',
            display: 'flex',
            alignItems: 'center',
            gap: '6px',
            fontFamily
        };
        
        const searchBtn = {
            ...button,
            background: '#f8f9fa',
            color: '#395d9a',
            border: '1px solid #e0e7ef'
        };
        
        const uploadBtn = {
            ...button,
            background: 'linear-gradient(90deg, #2bbbad 0%, #395d9a 100%)',
            color: 'white',
            boxShadow: '0 2px 8px rgba(57,93,154,0.15)'
        };
        
        const downloadBtn = {
            ...button,
            background: '#e74c3c',
            color: 'white'
        };
        
        const select = {
            padding: '8px 12px',
            border: '1px solid #e0e7ef',
            borderRadius: 0,
            fontSize: '14px',
            background: 'white',
            fontFamily,
            minWidth: '200px'
        };
        
        const content = {
            padding: '24px',
            height: 'calc(100vh - 200px)',
            overflow: 'auto'
        };
        
        const tableContainer = {
            background: 'white',
            borderRadius: '12px',
            boxShadow: '0 4px 20px rgba(57,93,154,0.08)',
            overflow: 'hidden',
            border: '1px solid #e0e7ef',
            maxHeight: 'calc(100vh - 240px)',
            display: 'flex',
            flexDirection: 'column'
        };
        
        const table = {
            width: '100%',
            borderCollapse: 'collapse',
            fontFamily,
            flex: 1,
            overflow: 'auto'
        };
        
        const th = {
            background: '#f8f9fa',
            color: '#395d9a',
            fontWeight: '700',
            fontSize: '14px',
            padding: '16px 12px',
            textAlign: 'left',
            borderBottom: '2px solid #e0e7ef',
            position: 'sticky',
            top: 0,
            zIndex: 2
        };
        
        const td = {
            padding: '14px 12px',
            borderBottom: '1px solid #f0f0f0',
            fontSize: '14px',
            color: '#333'
        };
        
        const claimLink = {
            color: '#2bbbad',
            fontWeight: '600',
            cursor: 'pointer',
            textDecoration: 'none'
        };
        
        const pagination = {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '16px',
            padding: '20px',
            background: '#f8f9fa',
            borderTop: '1px solid #e0e7ef',
            position: 'sticky',
            bottom: 0,
            zIndex: 1
        };
        
        const paginationBtn = {
            ...button,
            background: '#f8f9fa',
            color: '#395d9a',
            border: '1px solid #e0e7ef',
            padding: '6px 12px'
        };
        
        const responsive = `
            @media (max-width: 768px) {
                .gis-header { flex-direction: column; align-items: stretch; }
                .gis-controls { flex-direction: column; align-items: stretch; }
                .gis-search { min-width: 100%; }
                .gis-table { font-size: 12px; }
                .gis-th, .gis-td { padding: 8px 6px; }
            }
            @media (max-width: 480px) {
                .gis-content { padding: 16px; }
                .gis-table { font-size: 11px; }
                .gis-th, .gis-td { padding: 6px 4px; }
            }
        `;

        return (
            <div style={container}>
                <style>{responsive}</style>
                
                {/* Header */}
                <div className="gis-header" style={header}>
                    <div style={headerLeft}>
                        <div style={headerTitle}>
                            <span className="fa fa-list"/>
                            GIS Approval Data
                        </div>
                    </div>
                    <div style={headerRight}>
                        <span className="fa fa-history" style={{marginRight: '4px'}}/>
                        Updated 28 Minutes Ago
                    </div>
                </div>

                {/* Controls */}
                <div className="gis-controls" style={controlsSection}>
                    <div style={totalCount}>
                        <span className="fa fa-chart-bar"/>
                        Total: {this.state.count || 0}
                    </div>
                    
                    <input 
                        name="search" 
                        onChange={this.handleChanges} 
                        style={searchInput} 
                        placeholder="Search..."
                    />
                    
                    <button 
                        style={searchBtn}
                        onClick={() => this.searchData()}
                        onMouseOver={e => e.currentTarget.style.background = '#e9ecef'}
                        onMouseOut={e => e.currentTarget.style.background = '#f8f9fa'}
                    >
                        <span className="fa fa-search"/> Search
                    </button>
                    
                    <select 
                        name="village" 
                        style={select} 
                        onChange={this.handleChanges}
                    >
                        <option value={undefined}>- Choose Village -</option>
                        {this.state.villages.map((d, i) => (
                            <option value={d.id} key={i}>{d.name}</option>
                        ))}
                    </select>
                    
                    <button 
                        style={downloadBtn}
                        onClick={() => this.downloadExcel()}
                        onMouseOver={e => e.currentTarget.style.background = '#c0392b'}
                        onMouseOut={e => e.currentTarget.style.background = '#e74c3c'}
                    >
                        <span className="fa fa-download"/> Public Display
                    </button>
                    
                    <button 
                        style={{...button, background: 'linear-gradient(90deg, #fd7e14 0%, #e8590c 100%)', color: 'white'}}
                        onClick={() => this.previewParcels()}
                        onMouseOver={e => e.currentTarget.style.background = 'linear-gradient(90deg, #e8590c 0%, #fd7e14 100%)'}
                        onMouseOut={e => e.currentTarget.style.background = 'linear-gradient(90deg, #fd7e14 0%, #e8590c 100%)'}
                    >
                        <span className="fa fa-eye"/> View
                    </button>
                    
                    <button 
                        style={uploadBtn}
                        onClick={() => PopDetail.showDynamic('Upload Shapefile',
                            <CCROUploadShpPane 
                                project={this.props.project} 
                                task_id={this.props.taskId} 
                                screen_code={this.props.screen_code}
                                loadData={() => this.loadData()} 
                                key={new Date()}
                            />, 40, 40
                        )}
                        onMouseOver={e => e.currentTarget.style.background = 'linear-gradient(90deg, #229954 0%, #2c3e50 100%)'}
                        onMouseOut={e => e.currentTarget.style.background = 'linear-gradient(90deg, #2bbbad 0%, #395d9a 100%)'}
                    >
                        <span className="fa fa-upload"/> Upload .SHP
                    </button>
                </div>

                {/* Content */}
                <div className="gis-content" style={content}>
                    <div style={tableContainer}>
                        <div style={{flex: 1, overflow: 'auto'}}>
                            <table className="gis-table" style={table}>
                            <thead>
                                <tr>
                                    <th className="gis-th" style={th}>#</th>
                                    <th className="gis-th" style={th}>Registration Date</th>
                                    <th className="gis-th" style={th}>Claim No</th>
                                    <th className="gis-th" style={th}>Use</th>
                                    <th className="gis-th" style={th}>Parties</th>
                                    <th className="gis-th" style={th}>Approval Date</th>
                                    <th className="gis-th" style={th}>Approved By</th>
                                    <th className="gis-th" style={th}>Village</th>
                                    <th className="gis-th" style={th}>Hamlet</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.data.map((d, i) => (
                                    <tr key={i} style={{background: i % 2 === 0 ? '#f8f9fa' : 'white'}}>
                                        <td className="gis-td" style={td}>
                                            {this.state.next === null
                                                ? this.state.previous !== null
                                                    ? this.state.previous.split('=').length > 1
                                                        ? (this.state.previous.split('=')[1] * this.state.pageSize) + i + 1
                                                        : this.state.pageSize + i + 1
                                                    : 0 + i + 1
                                                : (this.state.next.split('=')[1] - 1) > 1
                                                    ? (this.state.next.split('=')[1] - 2) * this.state.pageSize + i + 1
                                                    : i + 1
                                            }
                                        </td>
                                        <td className="gis-td" style={td}>{d.claim_date}</td>
                                        <td className="gis-td" style={td}>
                                            <span 
                                                style={claimLink}
                                                onClick={() => PopDetail.show(d.claim_no,
                                                    <PlotDetailPane 
                                                        screen_code={this.props.screen_code} 
                                                        taskId={this.props.taskId} 
                                                        parcel={d} 
                                                        key={new Date().getMilliseconds()}
                                                    />
                                                )}
                                            >
                                                {d.claim_no}
                                            </span>
                                        </td>
                                        <td className="gis-td" style={td}>{d.use}</td>
                                        <td className="gis-td" style={td}>
                                            {d.parties.map((party, j) => (
                                                <div key={j} style={{marginBottom: '2px'}}>{party}</div>
                                            ))}
                                        </td>
                                        <td className="gis-td" style={td}>{d.datetime}</td>
                                        <td className="gis-td" style={td}>{d.datetime}</td>
                                        <td className="gis-td" style={td}>{d.locality_info?.village}</td>
                                        <td className="gis-td" style={td}>{d.locality_info?.hamlet}</td>
                                    </tr>
                                ))}
                                {this.state.data.length === 0 && (
                                    <tr>
                                        <td colSpan="9" style={{...td, textAlign: 'center', color: '#666', padding: '40px'}}>
                                            No data found
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                        </div>
                        
                        {/* Pagination */}
                        <div style={pagination}>
                            <button 
                                style={paginationBtn}
                                onClick={() => {
                                    this.setState({
                                        newPageSize: this.state.newPageSize - this.state.pageSize
                                    })
                                    this.fetchProjectsByUrl(this.state.previous)
                                }}
                                onMouseOver={e => e.currentTarget.style.background = '#e9ecef'}
                                onMouseOut={e => e.currentTarget.style.background = '#f8f9fa'}
                                disabled={!this.state.previous}
                            >
                                Back
                            </button>
                            <span style={{fontWeight: '600', color: '#395d9a'}}>
                                {this.state.totalPages === 0 ? 0 : (this.state.newPageSize) / this.state.pageSize}/{this.state.totalPages}
                            </span>
                            <button 
                                style={paginationBtn}
                                onClick={() => {
                                    this.setState({
                                        newPageSize: this.state.pageSize + this.state.newPageSize
                                    })
                                    this.fetchProjectsByUrl(this.state.next)
                                }}
                                onMouseOver={e => e.currentTarget.style.background = '#e9ecef'}
                                onMouseOut={e => e.currentTarget.style.background = '#f8f9fa'}
                                disabled={!this.state.next}
                            >
                                Next
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    previewParcels() {
        try {
            let village_id = parseInt(this.state.village_id)

            if (village_id === undefined || village_id === 0) {
                alert('Please select a village first')
                return
            }

            // Get the stage - using 'gis_approval' for this component
            let stage = 'gis_approval';

            Wait.show('Loading parcels preview...')
            
            // Construct the direct URL for the parcels map
            const parcelsMapUrl = `${baseUrl()}/collect/ccro/parcels/map?village_id=${village_id}&stage=${stage}`;
            
            // Open the URL directly in a new tab
            const newWindow = window.open(parcelsMapUrl, '_blank');
            
            if (!newWindow) {
                alert('Please allow popups for this site to view the parcels preview');
            }
            
            Wait.dismiss()
            
        } catch (e) {
            Wait.dismiss()
            console.error('Error in previewParcels:', e);
            alert('Error loading parcels preview. Please try again.');
        }
    }
}
